export default [
  {
    path: '/settings/customization',
    name: 'settings-customization',
    component: () => import('@/views/sistema/customizacao/Customizacao.vue'),
    meta: {
      pageTitle: 'Customização',
      breadcrumb: [
        { text: 'Configurações' },
        { text: 'Customização', active: true },
      ],
      resource: 'Customizacao',
      action: 'read',
    },
  },
];
